<div class="row bluechatMassCreation-content">
    <div class="col-sm-6 partLeft">
        <span [i18n]="'bluechat.mass-creation.delivery-selection.'+(loads.length > 0 ? 'selection' : 'no-selection')"></span>
        <spacer [size]="8"></spacer>
        <app-bluechat-delivery-list [loads]="loads" *ngIf="loads.length > 0"></app-bluechat-delivery-list>
        <spacer [size]="8"></spacer>
        <div class="text-center">
            <span *ngIf="loads.length > 0" [i18n]="'bluechat.mass-creation.delivery-selection.label'"></span>
            <spacer [size]="8"></spacer>
            <button
                [i18n]="'bluechat.mass-creation.delivery-selection.create-button-text'"
                [disabled]="loads.length == 0"
                class="btn btn-small btn-primary"
                type="button"
                (click)="createFromList()">
            </button>
        </div>
    </div>

    <div class="col-sm-6 partRight" *ngIf="showCsvImport">
        <div class="partRight-top">
            <span [i18n]="'bluechat.mass-creation.csv-import.import.main'"></span><br>
            <spacer [size]="8"></spacer>
            <app-file-upload [labelKey]="'bluechat.mass-creation.csv-import.import.label'"
                             [acceptedFileTypes]="['text/csv']"
                             (onFileAdded)="changeSelectedCsv($event)">
            </app-file-upload>
            <spacer [size]="8"></spacer>
            <div class="row">
                <div class="col-sm-6">
                    <small [i18n]="'bluechat.mass-creation.csv-import.import.sub-label'"></small>
                </div>
                <div class="col-sm-6 text-right">
                    <small [i18n]="'bluechat.mass-creation.csv-import.import.format'"></small>
                </div>
            </div>
            <spacer [size]="12"></spacer>
            <app-file-preview [file]="selectedCsvFile" (deleteFileEvent)="deleteCsv(); resetState();"></app-file-preview>
            <spacer [size]="12"></spacer>
        </div>

        <div class="partRight-bottom">
            <div *ngIf="selectedCsvFile">
                <span [i18n]="'bluechat.mass-creation.csv-import.import.column-selection'"></span>
                <ng-select [(ngModel)]="selectedColumn" (ngModelChange)="updateDeliveryNumbers($event)">
                    <ng-option *ngFor="let column of columns" [value]="column">{{column}}</ng-option>
                </ng-select>
                <spacer [size]="12"></spacer>
                <app-csv-column-preview
                    *ngIf="csv && selectedColumn"
                    [column]="selectedColumn"
                    [csvData]="csv">
                </app-csv-column-preview>
            </div>
            <spacer [size]="8"></spacer>

            <div>
                <div class="row" *ngIf="!carrierSearchError else carrierError">
                    <div class="col-xs-12 text-center">
                        <button [disabled]="!selectedColumn"
                                [ngClass]="parsingInProgress ? 'spin' : ''"
                                [i18n]="'bluechat.mass-creation.csv-import.button.create-label-text'"
                                class="btn btn-small btn-primary"
                                type="button"
                                (click)="createFromCsv()">
                        </button>
                    </div>
                </div>

                <ng-template #carrierError>
                    <app-error>
                        <i class="fa fa-warning"></i>
                        <div class="text">
                            <strong [i18n]="'bluechat.mass-creation.csv-import.carrier-error.main-warning'"></strong>
                        </div>
                    </app-error>
                    <spacer [size]="8"></spacer>

                    <div  *ngIf="incorrectDeliveriesBecauseNotKnown.length > 0">
                        <span [i18n]="'bluechat.mass-creation.csv-import.carrier-error.not-known.label'"></span>
                        <app-bluechat-simple-carrier-delivery-list
                            [bluechatFindByDeliveryNumberLoad]="incorrectDeliveriesBecauseNotKnown">
                        </app-bluechat-simple-carrier-delivery-list>
                        <spacer [size]="8"></spacer>
                        <app-info>
                            <i class="fa fa-info-circle"></i>
                            <div class="text">
                                <strong [i18n]="'bluechat.mass-creation.csv-import.carrier-error.not-known.info'"></strong>
                            </div>
                        </app-info>
                    </div>

                    <spacer [size]="12"></spacer>

                    <div *ngIf="incorrectDeliveriesBecauseNoBluechat.length > 0">
                        <span [i18n]="'bluechat.mass-creation.csv-import.carrier-error.no-bluechat.label'"></span>
                        <app-bluechat-simple-carrier-delivery-list
                            [bluechatFindByDeliveryNumberLoad]="incorrectDeliveriesBecauseNoBluechat">
                        </app-bluechat-simple-carrier-delivery-list>
                        <spacer [size]="8"></spacer>
                        <app-info>
                            <i class="fa fa-info-circle"></i>
                            <div class="text">
                                <strong [i18n]="'bluechat.mass-creation.csv-import.carrier-error.no-bluechat.info'"></strong>
                            </div>
                        </app-info>
                    </div>

                    <spacer [size]="12"></spacer>

                    <app-error *ngIf="correctDeliveries.length === 0">
                        <i class="fa fa-warning"></i>
                        <div class="text">
                            <strong [i18n]="'bluechat.mass-creation.csv-import.carrier-error.no-correct-loads'"></strong>
                        </div>
                    </app-error>

                    <spacer [size]="12"></spacer>

                    <div class="row">
                        <div class="text-center col-xs-12">
                            <button
                                [disabled]="!selectedColumn || correctDeliveries.length === 0 || parsingInProgress"
                                [ngClass]="parsingInProgress ? 'spin' : ''"
                                [i18n]="'bluechat.mass-creation.csv-import.button.force-create-text'"
                                class="btn btn-small btn-primary"
                                type="button"
                                (click)="createFromCsvForced()">
                            </button>
                        </div>
                    </div>
                </ng-template>
            </div>
        </div>
    </div>
</div>
